import {
  AllTagsDocument
} from '@transactions/graphql';
import type {DataProxy} from '@apollo/client';
import type {
  AllTagsQuery,
  FullTagFragment} from '@transactions/graphql';

export const addNewTags = (store: DataProxy, newTags: FullTagFragment[]) => {
  const data = store.readQuery<AllTagsQuery>({query: AllTagsDocument});
  const tags: FullTagFragment[] = data?.allTags || [];

  // One write with every missing tag — a write per tag would rebuild from
  // the same snapshot each time, so each would overwrite the one before it
  // and only the last new tag would survive.
  const seen = new Set(tags.map((t) => t._id));
  const missing = newTags.filter((newTag) => {
    if (seen.has(newTag._id)) return false;
    seen.add(newTag._id);
    return true;
  });
  if (missing.length > 0) {
    store.writeQuery({
      query: AllTagsDocument,
      data: {
        allTags: [...tags, ...missing],
      },
    });
  }
};
